import React, { useEffect, useState } from 'react';
interface CountdownProps {
  initialHours?: number;
  initialMinutes?: number;
  initialSeconds?: number;
  className?: string;
  theme?: 'light' | 'dark' | 'danger' | 'premium';
}
export function Countdown({
  initialHours = 23,
  initialMinutes = 27,
  initialSeconds = 35,
  className = '',
  theme = 'danger'
}: CountdownProps) {
  const [timeLeft, setTimeLeft] = useState({
    hours: initialHours,
    minutes: initialMinutes,
    seconds: initialSeconds
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.hours === 0 && prev.minutes === 0 && prev.seconds === 0) {
          clearInterval(timer);
          return prev;
        }
        let newSeconds = prev.seconds - 1;
        let newMinutes = prev.minutes;
        let newHours = prev.hours;
        if (newSeconds < 0) {
          newSeconds = 59;
          newMinutes -= 1;
        }
        if (newMinutes < 0) {
          newMinutes = 59;
          newHours -= 1;
        }
        return {
          hours: newHours,
          minutes: newMinutes,
          seconds: newSeconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatNumber = (num: number) => num.toString().padStart(2, '0');
  const themes = {
    light: 'bg-white text-slate-900 border-slate-200',
    dark: 'bg-[#0f1d35] text-white border-[#1e3a5f]',
    danger: 'bg-red-50 text-red-600 border-red-200',
    premium: 'bg-slate-200/10 text-slate-200 border-slate-300/30'
  };
  return <div className={`inline-flex items-center gap-2 font-mono font-bold text-lg md:text-2xl px-4 py-2 rounded-lg border ${themes[theme]} ${className}`} data-id="element-354">
      <div className="flex flex-col items-center" data-id="element-355">
        <span data-id="element-356">{formatNumber(timeLeft.hours)}</span>
        <span className="text-[10px] uppercase tracking-wider opacity-70 font-sans" data-id="element-357">
          hs
        </span>
      </div>
      <span className="opacity-50 pb-4" data-id="element-358">:</span>
      <div className="flex flex-col items-center" data-id="element-359">
        <span data-id="element-360">{formatNumber(timeLeft.minutes)}</span>
        <span className="text-[10px] uppercase tracking-wider opacity-70 font-sans" data-id="element-361">
          min
        </span>
      </div>
      <span className="opacity-50 pb-4" data-id="element-362">:</span>
      <div className="flex flex-col items-center" data-id="element-363">
        <span data-id="element-364">{formatNumber(timeLeft.seconds)}</span>
        <span className="text-[10px] uppercase tracking-wider opacity-70 font-sans" data-id="element-365">
          seg
        </span>
      </div>
    </div>;
}